import { AppConfig } from '../config';
import { fetchWithAuth } from './fetchWithAuth';

export interface DownloadAiAnalysisPdfOptions {
  sessionId: string;
  messageId: string;
}

function filenameFromContentDisposition(header: string | null, fallback: string): string {
  if (!header) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header);
  return match?.[1] ? decodeURIComponent(match[1]) : fallback;
}

class AiAnalysisPdfApi {
  async download({ sessionId, messageId }: DownloadAiAnalysisPdfOptions): Promise<void> {
    const response = await fetchWithAuth(
      `${AppConfig.apiRoot}ai-analysis/sessions/${sessionId}/messages/${messageId}/pdf`,
      { method: 'GET' },
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Download failed: ${response.status} ${errorText}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const fallback = `AI_Analysis_${messageId.slice(0, 8)}.pdf`;
    const filename = filenameFromContentDisposition(
      response.headers.get('Content-Disposition'),
      fallback,
    );

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export const aiAnalysisPdfApi = new AiAnalysisPdfApi();
